import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAnxN66OmpLSQlw2yWRCFrXpnZD3kZi3KY",
  authDomain: "deck-builder-2b08c.firebaseapp.com",
  projectId: "deck-builder-2b08c",
  storageBucket: "deck-builder-2b08c.firebasestorage.app",
  messagingSenderId: "82146653422",
  appId: "1:82146653422:web:2d5aaf858f8770dd24efff",
  measurementId: "G-DT6M7QSRF3"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
